import ErrorPage from '@/components/ErrorPage';

export default function Error500() {
  return (
    <ErrorPage
      errorCode="500"
      title="Things Got a Bit Unstable"
      message="Like a tower of macarons, something in our system toppled over. Our team has been notified and we're working to fix it."
      imagePath="/error-500.png"
      showRefresh={true}
    />
  );
}